<template>
  <div id="quality-control">
    <br />
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ 'tab-selector': true, active: status.date }"
          href="#"
          @click="selectedDate()"
          >ผลการทดสอบประจำวัน</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ 'tab-selector': true, active: status.graph }"
          href="#"
          @click="selectedGraph()"
          >ประมวลผลการทดสอบ</a
        >
      </li>
    </ul>
    <br />
    <br />
    <quality-control-table v-show="status.date" />
    <quality-control-graph v-show="status.graph" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import QualityControlTable from "../../components/QualityControl/QualityControlTable.vue";
import QualityControlGraph from "../../components/QualityControl/QualityControlGraph.vue";
export default {
  components: { QualityControlTable, QualityControlGraph },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters({ status: "QualityControl/getStatus" }),
  },
  methods: {
    ...mapActions({
      changeStatus: "QualityControl/changeStatus",
    }),
    selectedDate() {
      const date = true;
      const graph = false;
      this.changeStatus({ date, graph });
    },
    selectedGraph() {
      const date = false;
      const graph = true;
      this.changeStatus({ date, graph });
    },
  },
};
</script>

<style scoped>
.nav-link {
  font-weight: bold;
}
#quality-control {
  width: 95vw;
  margin: 0 auto;
}
.right {
  text-align: right;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
